import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    emptyCartContainer: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        maxWidth: 300,
        margin: '0 auto',
    },
    emptyCartText: {
        fontSize: '1.25rem',
        marginBottom: '1rem',
    },
    emptyCartButton: {
        fontWeight: 'bold',
        textTransform: 'none',
        marginBottom: '1rem',
    },
}))

const EmptyCart = ({ baseUrl }) => {
    const classes = useStyles()
    return (
        <Grid item xs={12} className={classes.emptyCartContainer}>
            <Typography variant="body1" className={classes.emptyCartText}>
                Your cart is empty
            </Typography>
            <Button
                className={classes.emptyCartButton}
                href={`${baseUrl}/visa-gift-card/`}
                aria-label="Buy a Visa Gift Card"
                variant="contained"
                fullWidth
                color="primary"
                size="large"
            >
                Buy a Visa Gift Card
            </Button>
            <Button
                className={classes.emptyCartButton}
                href={`${baseUrl}/buy-gift-cards/`}
                aria-label="View All Gift Card Brands"
                variant="contained"
                fullWidth
                color="primary"
                size="large"
            >
                View All Gift Card Brands
            </Button>
        </Grid>
    )
}

export default EmptyCart
